import type { IActivityWireItem } from '@platform/dao';
import { displayNumber } from './displayNumber';

/**
 * Опис події «Нещодавньої активності» Головної, як рядок активності прототипу v4: «створив(-ла) запис» (англійською — «created this
 * faction», текст сервера), «прокоментував(-ла)», «пов’язано з 9»,
 * «зв’язок з 9 вилучено» (інший кінець — голим номером); зміни полів і решта — готовий текст сервера мовою користувача
 * («змінено «Статус» на «В роботі»»). Чиста функція.
 */
export function feedText(item: IActivityWireItem, t: (key: string, vars?: Record<string, unknown>) => string): string {
  switch (item.kind) {
    // сервер дає початок рядка прототипу мовою користувача: «створив(-ла) запис» / «created this faction» (однина типу запису)
    case 'created': return item.text || t('homePage.act.created');
    case 'comment': return t('homePage.act.commented');
    case 'linked': return item.otherDisplay ? t('homePage.act.linked', { other: displayNumber(item.otherDisplay) }) : t('homePage.act.linkedOther');
    case 'unlinked': return item.otherDisplay ? t('homePage.act.unlinked', { other: displayNumber(item.otherDisplay) }) : item.text;
    default: return item.text;
  }
}
